<div class="owner-block">
  <h6 *ngIf="!invalidDocsUploaded"
    class="text-black fw-semibold fs-14">{{!viewKycFromProfilePage ? 'Mandatory: Upload at least two documents to
    proceed with KYC verification' : 'KYC Documents' }}</h6>
  <p *ngIf="viewKycFromProfilePage"
    class="text-light fw-semibold fs-16">Access and manage your KYC documents from here</p>
  <p class="text-danger"
    *ngIf="invalidDocsUploaded && !viewKycFromProfilePage">We’ve marked the documents that need your attention. Please
    re-upload them to proceed
    with your KYC verification</p>
  <form [formGroup]="kycDocument">
    <div class="mb-4"
      *ngFor="let doc of selectedDocuments; let i = index">
      <p class="mb-1"
        [innerHTML]="doc.docName | textDifference">
        <span class="text-danger"
          *ngIf="doc.required">*</span>
      </p>
      <div class="position-relative file-input-control">
        <pmd-input-group-filled class="mb-2 cursor-pointer"
          [ngClass]="{'border border-danger rounded-3 overflow-hidden': kycDocument.get('documents').get(doc.name)?.value?.isVerified == false}">
          <pmd-input-group-text for="customFile01"
            (click)="openPreview(doc.name)">
            <label [for]="'file' + i"
              class="text-secondary text-sm fw-medium">
              {{ !kycDocument.get('documents').get(doc.name).value ? 'Choose File' : 'View'}}
            </label>
          </pmd-input-group-text>
          <input [type]="kycDocument.get('documents').get(doc.name).value?.name ? 'text' : 'file'"
            [value]="kycDocument.get('documents').get(doc.name).value?.name ? kycDocument.get('documents').get(doc.name).value?.name : null"
            class="form-control file-upload-control pe-5"
            ngFileSelect
            [id]="'file'+i"
            [accept]="doc.fileFormat.join(',')"
            [disabled]="viewKycFromProfilePage && kycDocument.get('documents').get(doc.name)?.value?.isVerified"
            [ngClass]="{'value-selected':kycDocument.get('documents').get(doc.name).value?.name ? kycDocument.get('documents').get(doc.name).value?.name : null}"
            (change)="onFileChange($event.target.files, doc.name)"
            #fileInput
            readonly>
          <div class="icon-delete"
            *ngIf="kycDocument.get('documents').get(doc.name).value"
            (click)="removeFile(doc.name, fileInput)"
            [hidden]="viewKycFromProfilePage && kycDocument.get('documents').get(doc.name)?.value?.isVerified">
            <svg width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.4375 4.0625V4.375H11.5625V4.0625C11.5625 3.6481 11.3979 3.25067 11.1049 2.95765C10.8118 2.66462 10.4144 2.5 10 2.5C9.5856 2.5 9.18817 2.66462 8.89515 2.95765C8.60212 3.25067 8.4375 3.6481 8.4375 4.0625ZM7.1875 4.375V4.0625C7.1875 3.31658 7.48382 2.60121 8.01126 2.07376C8.53871 1.54632 9.25408 1.25 10 1.25C10.7459 1.25 11.4613 1.54632 11.9887 2.07376C12.5162 2.60121 12.8125 3.31658 12.8125 4.0625V4.375H17.5C17.6658 4.375 17.8247 4.44085 17.9419 4.55806C18.0592 4.67527 18.125 4.83424 18.125 5C18.125 5.16576 18.0592 5.32473 17.9419 5.44194C17.8247 5.55915 17.6658 5.625 17.5 5.625H16.5575L15.375 15.98C15.2878 16.7426 14.923 17.4465 14.3501 17.9573C13.7772 18.4682 13.0363 18.7504 12.2687 18.75H7.73125C6.96366 18.7504 6.22279 18.4682 5.64991 17.9573C5.07702 17.4465 4.7122 16.7426 4.625 15.98L3.4425 5.625H2.5C2.33424 5.625 2.17527 5.55915 2.05806 5.44194C1.94085 5.32473 1.875 5.16576 1.875 5C1.875 4.83424 1.94085 4.67527 2.05806 4.55806C2.17527 4.44085 2.33424 4.375 2.5 4.375H7.1875ZM5.8675 15.8375C5.91968 16.2949 6.13835 16.7172 6.48183 17.0238C6.82531 17.3304 7.26959 17.4999 7.73 17.5H12.2694C12.7298 17.4999 13.1741 17.3304 13.5175 17.0238C13.861 16.7172 14.0797 16.2949 14.1319 15.8375L15.3 5.625H4.70062L5.8675 15.8375ZM8.125 7.8125C8.29076 7.8125 8.44973 7.87835 8.56694 7.99556C8.68415 8.11277 8.75 8.27174 8.75 8.4375V14.6875C8.75 14.8533 8.68415 15.0122 8.56694 15.1294C8.44973 15.2467 8.29076 15.3125 8.125 15.3125C7.95924 15.3125 7.80027 15.2467 7.68306 15.1294C7.56585 15.0122 7.5 14.8533 7.5 14.6875V8.4375C7.5 8.27174 7.56585 8.11277 7.68306 7.99556C7.80027 7.87835 7.95924 7.8125 8.125 7.8125ZM12.5 8.4375C12.5 8.27174 12.4342 8.11277 12.3169 7.99556C12.1997 7.87835 12.0408 7.8125 11.875 7.8125C11.7092 7.8125 11.5503 7.87835 11.4331 7.99556C11.3158 8.11277 11.25 8.27174 11.25 8.4375V14.6875C11.25 14.8533 11.3158 15.0122 11.4331 15.1294C11.5503 15.2467 11.7092 15.3125 11.875 15.3125C12.0408 15.3125 12.1997 15.2467 12.3169 15.1294C12.4342 15.0122 12.5 14.8533 12.5 14.6875V8.4375Z"
                fill="#212121" />
            </svg>
          </div>
        </pmd-input-group-filled>
        <p class="text-danger fw-medium text-xs"
          *ngIf="!kycDocument.get('documents').get(doc.name)?.value?.isVerified">
          <span>{{kycDocument.get('documents').get(doc.name)?.value?.verificationDescription || ''}}</span>
        </p>
      </div>
      <!-- Preview Component -->

      <div *ngIf="kycDocument.get('documents').get(doc.name)?.errors?.required"
        class="text-danger">
        This file is required
      </div>
      <div *ngIf="kycDocument.get('documents').get(doc.name)?.errors?.invalidFileType"
        class="text-danger">
        Invalid file type. Allowed types: {{ doc.fileFormat | removePrefix }}
      </div>
    </div>
  </form>
</div>

<div pmdModal
  #document_uploaded="pmd-modal"
  class="modal pmd-modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="vertically-centered">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Modal Body -->
      <div class="modal-body">
        <div class="d-flex align-items-center flex-column">
          <img src="assets/images/document-uploaded.gif"
            alt="document-uploaded.gif"
            class="w-25">
          <p class="fs-6 text-dark fw-semibold">Documents uploaded successfully
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<div pmdModal
  #upload_failed="pmd-modal"
  class="modal pmd-modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="vertically-centered">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content">
      <!-- Modal Body -->
      <div class="modal-body py-4">
        <div class="d-flex align-items-center flex-column">
          <svg width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <rect width="56"
              height="56"
              rx="28"
              fill="#FFF5F6" />
            <path
              d="M27.0249 41.4318C27.3342 41.6122 27.4888 41.7024 27.707 41.7492C27.8764 41.7855 28.1234 41.7855 28.2928 41.7492C28.511 41.7024 28.6656 41.6122 28.9748 41.4318C31.6959 39.8444 39.1742 34.8579 39.1742 28.0018V21.3218C39.1742 20.2051 39.1742 19.6467 38.9916 19.1667C38.8302 18.7427 38.568 18.3644 38.2277 18.0644C37.8424 17.7249 37.3196 17.5288 36.2739 17.1367L28.7846 14.3282C28.4942 14.2193 28.349 14.1648 28.1997 14.1433C28.0672 14.1241 27.9326 14.1241 27.8001 14.1433C27.6508 14.1648 27.5056 14.2193 27.2152 14.3282L19.7259 17.1367C18.6802 17.5288 18.1574 17.7249 17.7721 18.0644C17.4317 18.3644 17.1696 18.7427 17.0082 19.1667C16.8256 19.6467 16.8256 20.2051 16.8256 21.3218V28.0018C16.8256 34.8579 24.3039 39.8444 27.0249 41.4318Z"
              stroke="#D92D20"
              stroke-width="2.09519"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M30.8095 24.959L25.1902 30.5782M25.1902 24.959L30.8095 30.5782"
              stroke="#D92D20"
              stroke-width="2.09317"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <h6 class="mt-4 mb-2 text-black fw-semibold">Upload Failed</h6>
          <p class="mb-4">Some documents failed to upload. Please try again
          </p>
        </div>
        <div class="d-flex justify-content-center gap-3">
          <button type="button"
            pmdRipple
            pmd-btn
            pmd-btn-outline
            color="dark">Cancel</button>
          <button type="button"
            pmdRipple
            pmd-btn
            color="secondary"
            class="pmd-btn-min">Retry Upload</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div pmdModal
  #kycImagePreviewModal="pmd-modal"
  class="modal pmd-modal fade"
  tabindex="-1"
  role="dialog"
  (onShow)="selectedImageToPreview;"
  aria-labelledby="vertically-centered">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <app-zoom [path]="selectedImageToPreview"
        [showCloseIcon]="true"
        [isFullScreen]="false"
        class="me-2 w-100"
        (closeEvent)="kycImagePreviewModal.hide()">
      </app-zoom>
    </div>
  </div>
</div>

<div pmdModal
  #kycPdfPreviewModal="pmd-modal"
  class="modal pmd-modal fade"
  tabindex="-1"
  role="dialog"
  (onShow)="selectedPdfToPreview;"
  aria-labelledby="vertically-centered">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <app-pdf-zoom [path]="selectedPdfToPreview"
        [showCloseIcon]="true"
        (closeEvent)="kycPdfPreviewModal.hide()"
        [isFullScreen]="false"
        [zoomScale]="'page-height'"
        class="me-2 w-100">
      </app-pdf-zoom>
    </div>
  </div>
</div>